import { format, R } from '@/features/booking/resources/Texts.resx';
import { Button, Modal } from '@/components';

type AdultHouseholdMemberWarningModalProps = {
    onClose: () => void;
    adolescentMinimumAge: number;
};

export const AdultHouseholdMemberWarningModal = ({
    onClose,
    adolescentMinimumAge,
}: AdultHouseholdMemberWarningModalProps) => {
    return (
        <Modal onClose={onClose} title={R.AdultWarningBookingTitle}>
            <p className="text-text-primary">
                {' '}
                {format(
                    R.AdultWarningBookingText,
                    adolescentMinimumAge.toString(),
                )}
            </p>
            <div className="flex justify-end">
                <Button
                    onClick={() => {
                        onClose();
                        window.location.href = '/profile/household';
                    }}
                >
                    {R.GoToProfile}
                </Button>
            </div>
        </Modal>
    );
};
